import './App.scss';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BrowserRouter, HashRouter } from 'react-router-dom';
import Routing from './routing/Routing';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { UserProvider } from './hooks/useUser';
import ScrollToTop from './component/scroll/ScrollTop';

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 0,
        refetchOnWindowFocus: false
      }
    }
  })

  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
       {/* <HelmetProvider> */}
        {/* <HashRouter> */}
        {/* <BrowserRouter basename='/hollypills_web_stage/'> */}
        <BrowserRouter basename='/'>

          <ScrollToTop />
          <UserProvider>
            <Routing />
          </UserProvider>
        </BrowserRouter>
        {/* </HashRouter> */}
       {/* </HelmetProvider> */}
      </QueryClientProvider>
    </div>
  );
}

export default App;
